<mat-card
  matRipple
  [matRippleDisabled]="!clickable"
  [class.mat-elevation-z0]="true"
  [class.compact]="isCompact"
  [class.clickable]="clickable"
  [class.border]="hasBorder()"
  [class.rounded]="true"
>
  <mat-card-header class="pb-2">
    <mat-card-title
      class="pt-2 mat-title-medium d-flex w-100 gap-2 align-items-center"
      style="font-size: 1.2rem"
    >
      @if(spot()?.isIconic) {
      <mat-icon
        style="width: 24px; flex-shrink: 0; margin: -2px"
        matTooltip="Iconic Spot"
        i18n-matTootltip
        >stars</mat-icon
      >
      }
      <span class="text-truncate">{{ spotName }}</span>
    </mat-card-title>
    <!-- @if(isCompact) { -->
    <mat-card-subtitle class="d-flex flex-row gap-2 mat-title-small">
      @if(spot()?.rating) {
      <app-spot-rating
        [rating1to5]="spot()?.rating ?? null"
        [showEmptyStars]="false"
        [isCompact]="true"
      ></app-spot-rating>
      }
      <span class="text-truncate" style="flex-shrink: 1">
        {{ spotLocality }}
      </span>
    </mat-card-subtitle>
    <!-- } -->
  </mat-card-header>

  <!-- <div class="button-row d-flex">
    @if (!visited) {
    <button
      mat-icon-button
      color="accent"
      matTooltip="Bookmark this spot"
      aria-label="Icon button with a bookmark icon"
      (click)="bookmarked = !bookmarked; $event.stopPropagation()"
    >
      <mat-icon>{{ bookmarked ? "bookmark" : "bookmark_border" }}</mat-icon>
    </button>

    }
    <button
      mat-icon-button
      color="primary"
      matTooltip="Mark this spot as visisted"
      aria-label="Icon button with a flag icon"
      (click)="visited = !visited; bookmarked = false; $event.stopPropagation()"
    >
      <mat-icon>{{ visited ? "flag" : "outlined_flag" }}</mat-icon>
    </button>
    <button
      mat-icon-button
      matTooltip="Share this spot"
      aria-label="Icon button with a share icon"
      (click)="shareSpot(); $event.stopPropagation()"
    >
      <mat-icon>share</mat-icon>
    </button>
  </div> -->
  @if(isCompact) { @if(media() && media().length > 0) {
  <div mat-card-sm-image class="img-container">
    <img [ngSrc]="media()[0]" fill />
  </div>

  } } @else { @if(media()) {
  <div class="img-container">
    <img [ngSrc]="media()[0]" fill priority />
    <!-- @if(showInfoButton()) {
    <button
      mat-icon-button
      style="
        position: absolute;
        right: 5px;
        bottom: 5px;
        background-color: var(--mat-bottom-sheet-container-background-color);
      "
      (click)="onClick()"
    >
      <mat-icon>info</mat-icon></button
    >} -->
  </div>
  } }
</mat-card>
